"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateItineraryTotalTransferCost = void 0;
const _ = require("lodash");
const calculateItineraryTotalTransferCost = (formData, transfer_rate_matrix) => {
    let total = 0;
    // get the transfer rates
    formData?.courses.itinerary.map((course) => {
        const date = course?.config?.where_when_who?.date;
        const from_location = formData?.transfers?.primary_pickup_area?.id;
        const to_location = course?.config?.course?.id;
        const rate = transfer_rate_matrix.filter((r) => {
            return (r.date === date &&
                ((r.from === from_location && r.to === to_location) ||
                    (r.from === to_location && r.to === from_location)));
        });
        // if more than one rate, get the cheapest
        const cheapest_rate = _.minBy(rate, "rate.total");
        if (cheapest_rate) {
            total += cheapest_rate.rate.total;
        }
    });
    return total;
};
exports.calculateItineraryTotalTransferCost = calculateItineraryTotalTransferCost;
